import ApprovalHolidayApplication from './ApprovalHolidayApplication'

export default ApprovalHolidayApplication